var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-group-tile cursor-pointer pa-2 mx-1",class:{'selected-product-group-tile': _vm.isSelected},on:{"click":_vm.selectProductGroup}},[_c('div',{staticClass:"text-body-2 noselect"},[_vm._v(_vm._s(_vm.productGroup.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }